import { createGrid } from "ag-grid-enterprise";

import { AgChartsCommunityModule } from "ag-charts-community";

// importa il css di ag-grid
import "ag-grid-enterprise/styles/ag-grid.css";
// Mi serve un tema che funzioni sullo scuro
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import { AG_GRID_LOCALE_IT } from "@ag-grid-community/locale";
import ResultsProvider from "./ResultsProvider";
import FilmografiaDetails from "./FilmografiaDetails";

import Pqp from "../../../../3x1010/Pqp.js";
import Game from "../../game/Game.js";
import FieldRender from "./FieldRender.js";
import * as Solr from "../../../../3x1010/Solr.js";
import PageCommon from "../../../PageCommon.js";

export default class QueryResults {
  constructor(qb, collectionName, target, resultsProvider, callback, additionalFields) {
    this.qb = qb;
    this.collectionName = collectionName;
    this.target = target;
    this.resultsProvider = resultsProvider;
    this.callback = callback;
    this.additionalFields = additionalFields;

    this.schema = new Solr.Schema(this.collectionName);
    this.fr = new FieldRender(this.collectionName);

    this.createPanelActions();
  }

  init() {
    this.showResults();
    const trg = jQuery(".js-btn-export", this.target);
    trg.on("click", () => {
      this.exportXls();
    });
  }

  dispose() {
    this.target.empty();
  }

  showResults() {
    const gridOptions = {
      masterDetail: true,
      detailRowAutoHeight: true,
      detailCellRenderer: FilmografiaDetails,
      columnDefs: this.getColumns(),
      rowModelType: "serverSide",
      pagination: true,
      paginationPageSize: 20,
      paginationPageSizeSelector: [10, 20, 50],
      cacheBlockSize: ResultsProvider.DEFAULT_ROWS_REQUESTED_TO_SERVER, // <<<< deve sempre essere maggiore o uguale alla paginationPageSize più grande
      serverSideDatasource: this.resultsProvider,
      localeText: AG_GRID_LOCALE_IT,
      suppressCellFocus: true,
      suppressRowHoverHighlight: true,
      suppressAnimationFrame: true,
      suppressRowVirtualisation: true,
      suppressRowTransform: true,
      //animateRows: false,
      defaultColDef: {
        maxWidth: 800,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        sortable: true,
        flex: 1,
        //filter: true,
        suppressHeaderFilterButton: true,
        //suppressMenu: true, // Rimuove il menu (i tre puntini) da tutte le colonne
        headerComponentParams: {
          template: `<div class="ag-cell-label-container" role="presentation">
                <span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>
                <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
                  <span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
                  <span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
                  <span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                </div>
              </div>`,
        },
      },
      suppressMenuHide: false,
      /*sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            minWidth: 225,
            maxWidth: 400,
            toolPanelParams: {
              suppressPivotMode: true, // Rimuove la possibilità di utilizzare il "Pivot Mode"
              suppressValues: true, // Rimuove la sezione dei valori
              suppressRowGroups: true, // Mantiene la possibilità di gestire i gruppi di righe
              suppressColumnSelectAll: true, // Rimuove il checkbox "Select All" nella lista delle colonne
              suppressColumnFilter: true, // Rimuove il filtro delle colonne
            },
          },
        ],

        defaultToolPanel: null,
      },*/
      sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressColumnFilter: false,
              suppressColumnSelectAll: false,
              suppressColumnExpandAll: false,
            },
          },
          /*{
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
            toolPanelParams: {},
          },*/
        ],
        defaultToolPanel: null,
      },
      autoSizeStrategy: {
        type: "fitCellContents",
        defaultMinWidth: 50,
      },

      /*rowSelection: {
        mode: "singleRow",
        checkboxes: false,
        enableClickSelection: true,
      },*/
      getRowId: (params) => params.data.id,
      //onRowClicked: (event) => {
      //event.node.setSelected(true); // Seleziona la riga cliccata
      //this.onRowClicked(event);
      //},
      onSortChanged: (params) => {
        // Forza ag-Grid a tornare alla prima pagina quando si cambia ordinamento
        params.api.paginationGoToFirstPage();
      },
    };

    this.addCustomGridOptions(gridOptions);

    this.grid = createGrid(this.target.get(0), gridOptions);
  }

  addCustomGridOptions(gridOptions) {
    // TO OVERRIDE
    return gridOptions;
  }

  getColumns() {
    console.log("getColumns TO OVERRIDE");
    return [];
  }

  dispatch(type, data) {
    if (this.callback) {
      //debugger;
      if (data) {
        data.collectionName = this.collectionName;
      }
      this.callback({
        type,
        data,
      });
    }
  }

  addCustomGridOptions(gridOptions) {
    // Override, aggiunge un contesto personalizzato
    gridOptions.context = {
      customPayload: {
        callback: this.dispatch.bind(this),
      },
    };
    return gridOptions;
  }

  createPanelActions() {
    const panel = jQuery("#template-results-actions").clone();
    panel.removeAttr("id");
    this.target.append(panel);

    let resizeButton = panel[0].querySelector(".js-resize-columns");
    let reduceButton = panel[0].querySelector(".js-reduce-columns");

    resizeButton.addEventListener("click", (e) => {
      this.doResize(this);
    });

    reduceButton.addEventListener("click", (e) => {
      this.grid.sizeColumnsToFit({
        defaultMinWidth: 52,
      });
    });
    // qui il codice per far funzionare i due pulsanti
  }

  doResize() {
    const allColumnIds = [];
    this.grid.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    this.grid.autoSizeColumns(allColumnIds, false);
  }

  checkIfIntermediatePathsAreArrays(fullPath) {
    const pathSegments = fullPath.split("/").filter((segment) => segment); // Split del percorso e rimozione degli elementi vuoti
    let currentPath = "";

    // Partiamo dall'indice 0 e ignoriamo l'ultimo segmento
    for (let i = 0; i < pathSegments.length - 1; i++) {
      currentPath += "/" + pathSegments[i];
      const field = this.schema.findFieldByPath(currentPath);
      if (field && field.IsArray) {
        return true;
      }
    }

    return false;
  }

  addAdditionalFields(columnDefs) {
    console.log(this.additionalFields);
    // Cerca ogni campo di additionalFields se esiiste già in columnDefs
    // se non esiste lo aggiunge

    if (this.additionalFields) {
      for (let x = 0; x < this.additionalFields.length; x++) {
        const field = this.additionalFields[x];
        let found = false;
        const def = this.schema.findFieldByPath(field);
        // I tipi complex li ignore
        if (def.Type === Solr.FieldType.ComplexField) {
          found = true;
        } else {
          for (let y = 0; y < columnDefs.length; y++) {
            if (columnDefs[y].field === def.Name) {
              found = true;
              break;
            }
          }
        }
        if (!found) {
          // Controlla se per caso nel suo path ci sono array e in quel caso lo ignora
          if (!this.checkArrayInPath(field)) {
            columnDefs.push(this.divineField(field));
          }
        }
      }

      return columnDefs;
    }
  }

  divineField(field) {
    const def = this.schema.findFieldByPath(field);
    console.log(def);
    return {
      pathForXls: field,
      field: def.Name,
      headerName: def.Label,
      autoHeight: true,
      wrapText: true,
      sortable: true,
      cellRenderer: (params) => {
        //debugger;
        const splitted = field.split("/");
        splitted.shift();
        //const lastProp = splitted.pop();
        //debugger;

        const a = this.selectTokens(params.data, field);

        const container = document.createElement("div");
        for (let x = 0; x < a.length; x++) {
          const div = document.createElement("div");
          div.innerHTML = a[x];
          container.appendChild(div);
        }
        return container;
        //const fieldContent = this.getValueFromPath(params.data, splitted);
        /*
        if (!fieldContent) {
          return "";
        }
        if (fieldContent === -1) {
          return "Dato complesso non visualizzabile";
        }

        //console.log(fieldContent);
        const container = document.createElement("div");
        const a = this.fr.getField(fieldContent);
        for (let x = 0; x < a.length; x++) {
          const value = a[x][lastProp];
          if (Array.isArray(value)) {
            for (let y = 0; y < value.length; y++) {
              const div = document.createElement("div");
              div.textContent = value[y];
              container.appendChild(div);
            }
          } else {
            const div = document.createElement("div");
            div.textContent = value;
            container.appendChild(div);
          }
        }
        return container;*/
      },
      flex: 2,
    };
  }

  selectTokens(obj, path) {
    let ret = [];
    let q = [obj];
    var parts = path.split("/").filter((x) => x != "");
    //
    for (let i = 0; i < parts.length; i++) {
      let done = [];
      for (let o of q) {
        let x = o.hasOwnProperty(parts[i]) ? o[parts[i]] : null;
        // caso 1
        if (i == parts.length - 1) {
          if (x == null) continue;
          //
          if (x instanceof Array) {
            for (let y of x) {
              let k = y != null ? y.toString() : null;
              if (k != null && ret.indexOf(k) == -1) ret.push(k);
            }
          } else {
            let k = x != null ? x.toString() : null;
            if (k != null && ret.indexOf(k) == -1) ret.push(k);
          }
        } else {
          if (x instanceof Array) {
            for (let y of x) {
              if (y instanceof Object) done.push(y);
            }
          } else if (x instanceof Object) {
            done.push(x);
          }
        }
      }
      //
      q = done;
    }
    //
    return ret;
  }

  /*  getValueFromPath(obj, pathArray) {
    return pathArray.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
  }*/
  getValueFromPath(obj, pathArray) {
    debugger;
    return pathArray.reduce((acc, key) => {
      if (acc && acc[key] !== undefined) {
        // Controlla se il valore corrente è un array
        if (Array.isArray(acc[key])) {
          if (acc[key].length > 1) {
            return -1;
          }
          return acc[key][0];
        }
        return acc[key];
      }
      return undefined;
    }, obj);
  }

  checkArrayInPath(field) {
    if (!QueryResults.CHECK_ARRAY_IN_PATH) {
      return false;
    }
    return this.checkIfIntermediatePathsAreArrays(field);
  }

  exportXls() {
    console.log(this.qb);
    console.log(this.columnDefs);
    const a = this.grid.getColumns();
    console.log(a);
    console.log(this.qb.query);
    //console.log(this.resultsProvider);
    /*for (let x = 0; x < a.length; x++) {
      const col = a[x];
      console.log(col);
      console.log(col.isVisible());
      console.log(col.getDefinition());
    }*/

    const query = this.qb.getQuery();
    let rq;
    if (query._searchType === ResultsProvider.SEARCH_TYPE_ADVANCED) {
      rq = {
        action: ResultsProvider.SEARCH_TYPE_ADVANCED,
        collectionName: this.qb.getCollection(),
        query: Solr.QueryWrapper.toJsonObject(query, this.qb.getCollection()),
        options: ResultsProvider.SEARCH_TYPE_ADVANCED_OPTIONS,
      };
    } else if (query._searchType === ResultsProvider.SEARCH_TYPE_ONFIELD) {
      rq = {
        action: ResultsProvider.SEARCH_TYPE_ONFIELD,
        collectionName: this.qb.getCollection(),
        query: this.qb.getQuery(),
        options: ResultsProvider.SEARCH_TYPE_ONFIELD_OPTIONS,
      };
    } else {
      rq = {
        action: ResultsProvider.SEARCH_TYPE_FULLTEXT,
        collectionName: this.qb.getCollection(),
        query: this.qb.getQuery(),
        options: ResultsProvider.SEARCH_TYPE_FULLTEXT_OPTIONS,
      };
    }

    rq.exportFields = this.getExportFields();
    /*rq.exportFields = [
      {
        FieldPath: "livello_RVEL",
        ExportType: "text",
      },
    ];*/

    console.log(rq);

    PageCommon.showPreloader(true);
    thatServiceManeger.standardCall("/api/solr/" + rq.action + "_export", rq, this.onDoneExport.bind(this));
  }

  getExportFields() {
    /*[
      {
        FieldPath: "definizione_oggetto_OGTD",
        ExportType: "string",
      },
    ];*/
    const fields = [];
    const a = this.columnDefs;
    for (let x = 0; x < a.length; x++) {
      let take = true;
      // lo cerca dentro le colonne
      const b = this.grid.getColumns();
      for (let y = 0; y < b.length; y++) {
        const def = b[y].getDefinition();
        if (def.field === a[x].field) {
          if (!b[y].isVisible()) {
            take = false;
          }
          break;
        }
      }
      if (take) {
        if (a[x].pathForXls) {
          const tmp = a[x].pathForXls.split("|");
          for (let y = 0; y < tmp.length; y++) {
            fields.push({
              FieldPath: tmp[y],
              ExportType: "text", //tmp[y].startsWith("/media/") ? "image" : "text",
            });
          }
        }
      }
    }
    return fields;
  }

  onDoneExport(data) {
    PageCommon.showPreloader(false);
    console.log(data);
    //window.open(data.data, "_blank");
    const url = data.data + "?rnd=" + Pqp.rnd(1000000000);
    console.log(url);
    document.location.href = url;
  }
}

QueryResults.EVENT_LOOK_FOR = "lookFor";
QueryResults.EVENT_OPEN_SCHEDA = "openScheda";
QueryResults.READ_COLUMN_HEADER_FROM_SCHEMA = true;
QueryResults.CHECK_ARRAY_IN_PATH = false;

QueryResults.SCHEDA_TYPE_FILM = "FILM";
QueryResults.SCHEDA_TYPE_ENITITA = "ENTITA";
QueryResults.SCHEDA_TYPE_COLLECTION = "COLLECTION";
